<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('edit_item') }}</h4>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/items" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <!-- /edit -->
  <form @submit.prevent="updateItem" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div class="accordion-header" id="headingOne">
              <div class="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseOne"  aria-controls="collapseOne">
                <div class="addproduct-icon">
                  <h5><i class="ti ti-info-circle"></i><span>{{ $t('general_information') }}</span></h5>
                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>
                </div>
              </div>
            </div>
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_code"
                        class="form-control"
                      />
                      <div v-if="errors.item_code" class="text-danger mt-2">
                        <span>{{ errors.item_code }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('sku') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.sku"
                        class="form-control"
                      />
                      <div v-if="errors.sku" class="text-danger mt-2">
                        <span>{{ errors.sku }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_name') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_name"
                        class="form-control"
                      />
                      <div v-if="errors.item_name" class="text-danger mt-2">
                        <span>{{ errors.item_name }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('category') }} <span class="text-danger">*</span> </label>
                      </div>
                      <VueSelect2
                        :modelValue="String(items.category)"
                        v-model="items.category"
                        :options="formattedCategories"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                          tags: true,
                        }"
                        @select="onChangeCategory"
                        class="form-control"
                      />
                      <div v-if="errors.category" class="text-danger">{{ errors.category }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('sub_category') }} <span class="text-danger">*</span></label>
                        </div>
                        <VueSelect2
                          :modelValue="String(items.sub_category)"
                          v-model="items.sub_category"
                          :options="formattedsub_categories"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                            tags: true,
                          }"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.sub_category" class="text-danger">{{ errors.sub_category }}</div>
                      </div>
                    </div>

<!--                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                    <div class="mb-3 add-product">-->
<!--                      <div class="add-newplus">-->
<!--                        <label class="form-label">{{ $t('warehouse') }} <span class="text-danger">*</span></label>-->
<!--                      </div>-->
<!--                      <VueSelect2-->
<!--                        :modelValue="String(items.warehouse)"-->
<!--                        v-model="items.warehouse"-->
<!--                        :options="formattedwarehouses"-->
<!--                        :settings="{-->
<!--                          placeholder: $t('select_an_option'),-->
<!--                          allowClear: true,-->
<!--                          tags: true,-->
<!--                        }"-->
<!--                        @change="onChange"-->
<!--                        class="form-control"-->
<!--                      />-->
<!--                      <div v-if="errors.warehouse" class="text-danger">{{ errors.warehouse }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample1">
          <div class="accordion-item">
            <div class="accordion-header" id="headingOn">
              <div class="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseOne"  aria-controls="collapseOne">
                <div class="addproduct-icon">
                  <h5><i class="ti ti-info-circle"></i><span>{{ $t('item_details') }}</span></h5>
                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>
                </div>
              </div>
            </div>
            <div id="collapseOn" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="add-product-new">
                  <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('size') }} <span class="text-danger">*</span></label>
                        </div>
                        <VueSelect2
                          :modelValue="String(items.size)"
                          v-model="items.size"
                          :options="formattedsizes"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                            tags: true,
                          }"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.size" class="text-danger">{{ errors.size }}</div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('color') }} <span class="text-danger">*</span></label>
                        </div>
                        <VueSelect2
                          :modelValue="String(items.color)"
                          v-model="items.color"
                          :options="formattedcolors"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                            tags: true,
                          }"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.color" class="text-danger">{{ errors.color }}</div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">
                          {{ $t('model_number') }} <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          v-model="items.model_number"
                          class="form-control"
                        />
                        <div v-if="errors.model_number" class="text-danger">{{ errors.model_number }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample4">
          <div class="accordion-item">
          <div class="accordion-header" id="headingFour">
            <div class="accordion-button"  data-bs-toggle="collapse" data-bs-target="#collapseFour"  aria-controls="collapseFour">
              <div class="text-editor add-list">
              <div class="addproduct-icon list">
                <h5><i class="ti ti-info-circle"></i><span>{{ $t('inventory_information') }}</span></h5>
                <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>
              </div>
            </div>
            </div>
          </div>
          <div id="collapseFour" class="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionExample4">
          <div class="accordion-body">
            <div class="text-editor add-list add">
              <div class="row">
<!--                <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                  <label class="form-label">{{ $t('stock_quantity') }} <span class="text-danger">*</span></label>-->
<!--                  <input-->
<!--                    type="text"-->
<!--                    v-model="items.stock_quantity"-->
<!--                    class="form-control"-->
<!--                  />-->
<!--                  <div v-if="errors.stock_quantity" class="text-danger mt-2">-->
<!--                    <span>{{ errors.stock_quantity }}</span>-->
<!--                  </div>-->
<!--                </div>-->

                <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                  <div class="mb-3 add-product">
                    <div class="add-newplus">
                      <label class="form-label">{{ $t('unit') }} <span class="text-danger">*</span></label>
                    </div>
                    <VueSelect2
                      :modelValue="String(items.unit)"
                      v-model="items.unit"
                      :options="formattedunits"
                      :settings="{
                        placeholder: $t('select_an_option'),
                        allowClear: true,
                        tags: true,
                      }"
                      @change="onChange"
                      class="form-control"
                    />
                    <div v-if="errors.unit" class="text-danger">{{ errors.unit }}</div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                  <div class="mb-3 add-product">
                    <label class="form-label">
                      {{ $t('reorder_level') }}
                    </label>
                    <input
                      type="text"
                      v-model="items.reorder_level"
                      class="form-control"
                    />
                    <div v-if="errors.reorder_level" class="text-danger">{{ errors.reorder_level }}</div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('barcode_qr_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.barcode_qr_code"
                        class="form-control"
                      />
                      <div v-if="errors.barcode_qr_code" class="text-danger">{{ errors.barcode_qr_code }}</div>
                    </div>
                  </div>

<!--                <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                  <div class="mb-3 position-relative">-->
<!--                    <label class="form-label fw-semibold">{{ $t('manufacturing_date') }}</label>-->
<!--                    <div class="input-group">-->
<!--                      <span class="input-group-text bg-white border-end-0">-->
<!--                        <i class="ti ti-calendar text-secondary"></i>-->
<!--                      </span>-->
<!--                      <input-->
<!--                        type="date"-->
<!--                        v-model="items.manufacturing_date"-->
<!--                        :format="'yyyy-MM-dd'"-->
<!--                        class="form-control border-start-0"-->
<!--                      />-->
<!--                    </div>-->
<!--                    <div v-if="errors.manufacturing_date" class="text-danger mt-1 small">-->
<!--                      <span>{{ errors.manufacturing_date }}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="row">
<!--                <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                  <div class="mb-3 position-relative">-->
<!--                    <label class="form-label fw-semibold">{{ $t('expire_date') }}</label>-->
<!--                    <div class="input-group">-->
<!--                      <span class="input-group-text bg-white border-end-0">-->
<!--                        <i class="ti ti-calendar text-secondary"></i>-->
<!--                      </span>-->
<!--                      <input-->
<!--                        type="date"-->
<!--                        v-model="items.expire_date"-->
<!--                        :format="'yyyy-MM-dd'"-->
<!--                        class="form-control border-start-0"-->
<!--                      />-->
<!--                    </div>-->
<!--                    <div v-if="errors.expire_date" class="text-danger mt-1 small">-->
<!--                      <span>{{ errors.expire_date }}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                    <div class="mb-3 add-product">-->
<!--                      <label class="form-label">-->
<!--                        {{ $t('item_serial_number') }} <span class="text-danger">*</span>-->
<!--                      </label>-->
<!--                      <input-->
<!--                        type="text"-->
<!--                        v-model="items.item_serial_number"-->
<!--                        class="form-control"-->
<!--                      />-->
<!--                      <div v-if="errors.item_serial_number" class="text-danger">{{ errors.item_serial_number }}</div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                    <div class="mb-3 add-product">-->
<!--                      <div class="add-newplus">-->
<!--                        <label class="form-label">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>-->
<!--                      </div>-->
<!--                      <VueSelect2-->
<!--                        :modelValue="String(items.supplier_name)"-->
<!--                        v-model="items.supplier_name"-->
<!--                        :options="formattedsuppliers"-->
<!--                        :settings="{-->
<!--                          placeholder: $t('select_an_option'),-->
<!--                          allowClear: true,-->
<!--                          tags: true,-->
<!--                        }"-->
<!--                        @change="onChange"-->
<!--                        class="form-control"-->
<!--                      />-->
<!--                      <div v-if="errors.supplier_name" class="text-danger">{{ errors.supplier_name }}</div>-->
<!--                    </div>-->
<!--                  </div>-->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

        <div class="accordion-card-one accordion" id="accordionExample2">
          <div class="accordion-item">
            <div class="accordion-header" id="headingTwo">
            <div class="accordion-button"  data-bs-toggle="collapse" data-bs-target="#collapseTwo"  aria-controls="collapseTwo">
              <div class="text-editor add-list">
                <div class="addproduct-icon list icon">
                  <h5><i class="ti ti-lifebuoy"></i><span>{{ $t("pricing_information") }}</span></h5>
                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>
                </div>
              </div>
            </div>
            </div>
            <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample2">
              <div class="accordion-body">
                <div class="tab-content" id="pills-tabContent">
                  <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                    aria-labelledby="pills-home-tab">
                    <div class="row">
<!--                      <div class="col-lg-3 col-md-3 col-sm-3 col-12">-->
<!--                        <label class="form-label">{{ $t('purchase_price') }} <span class="text-danger">*</span></label>-->
<!--                        <input-->
<!--                          type="text"-->
<!--                          v-model="items.purchase_price"-->
<!--                          class="form-control"-->
<!--                        />-->
<!--                        <div v-if="errors.purchase_price" class="text-danger mt-2">-->
<!--                          <span>{{ errors.purchase_price }}</span>-->
<!--                        </div>-->
<!--                      </div>-->

                      <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                        <label class="form-label">{{ $t('selling_price') }} <span class="text-danger">*</span></label>
                        <input
                          type="text"
                          v-model="items.selling_price"
                          class="form-control"
                        />
                        <div v-if="errors.selling_price" class="text-danger mt-2">
                          <span>{{ errors.selling_price }}</span>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                        <label class="form-label">{{ $t('discount') }} <span class="text-danger">*</span></label>
                        <input
                          type="text"
                          v-model="items.discount"
                          class="form-control"
                        />
                        <div v-if="errors.discount" class="text-danger mt-2">
                          <span>{{ errors.discount }}</span>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                        <label class="form-label">{{ $t('vat_group') }} <span class="text-danger">*</span></label>
                        <VueSelect2
                          :modelValue="String(items.vat_group)"
                          v-model="items.vat_group"
                          :options="formattedvatgroups"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                            tags: true,
                          }"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.vat_group" class="text-danger">{{ errors.vat_group }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample3">
          <div class="accordion-item">
            <div class="accordion-header" id="headingThree">
              <div class="accordion-button"  data-bs-toggle="collapse" data-bs-target="#collapseThree"  aria-controls="collapseThree">
                <div class="addproduct-icon list">
                  <h5><i class="ti ti-photo-plus"></i><span>{{ $t('images') }}</span></h5>
                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>
                </div>
              </div>
            </div>
            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
            <div class="accordion-body">
              <div class="text-editor add-list add">
                <div class="col-lg-12">
                  <div class="add-choosen">
                    <div class="input-blocks">
                      <div class="image-upload position-relative" style="width: 220px; height: 120px;">
                        <input
                          type="file"
                          class="form-control d-none"
                          id="imageUploadInput"
                          name="images"
                          @change="imageUpload"
                          accept="image/*"
                          multiple
                        />

                        <!-- Fixed-size upload box -->
                        <label
                          for="imageUploadInput"
                          class="d-flex flex-column align-items-center justify-content-center border border-primary rounded text-primary w-100 h-100"
                          style="cursor: pointer;"
                        >
                          <i class="ti ti-upload fs-1 mb-2"></i>
                          <h4 class="mb-0">{{ $t('add_images') }}</h4>
                        </label>

                        <!-- Error message show under the button -->
                        <div
                          v-if="errors.images"
                          class="text-danger small position-absolute start-0 bottom-n1 w-100 text-center"
                          style="transform: translateY(100%);"
                        >
                          {{ errors.images }}
                        </div>
                      </div>
                    </div>

                    <div class="phone-img"
                       v-for="(img, idx) in existingImages"
                       :key="'old-' + idx">

                      <img
                        :src="$getImageUrl(img.image)"
                        alt="existing image"
                      />

                      <a href="javascript:void(0);" @click="removeExistingImage(idx)">
                        <i class="ti ti-x"></i>
                      </a>
                    </div>

                    <div class="phone-img" v-for="(preview, index) in imagePreview" :key="index">
                      <img :src="preview" alt="image">
                      <a href="javascript:void(0);" @click="removeImage(index);"><i class="ti ti-x"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" >{{ $t('submit') }}</button>
      </div>
    </div>
  </form>

  <!-- /edit -->
  <CreateWarehouseModal
    id="create-modal1" @create_success="fetchWarehouse"
  />

  <CreateCategoryModal
    id="create-modal2" @create_success="fetchCategory"
  />

  <CreateSubCategoryModal
    id="create-modal3" @create_success="fetchCatSubCategories"
  />

  <CreateSizeModal
    id="create-modal4" @create_success="fetchSize"
  />

  <CreateColorModal
    id="create-modal5" @create_success="fetchColor"
  />

  <CreateUnitModal
    id="create-modal6" @create_success="fetchUnit"
  />

  <CreateSupplierModal
    id="create-modal7" @create_success="fetchSupplier"
  />
</div>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import CreateWarehouseModal from "@/views/admin_dashboard/item/CreateWarehouseModal.vue";
import CreateCategoryModal from "@/views/admin_dashboard/item/CreateCategoryModal.vue";
import CreateSubCategoryModal from "@/views/admin_dashboard/item/CreateSubCategoryModal.vue";
import CreateSizeModal from "@/views/admin_dashboard/item/CreateSizeModal.vue";
import CreateColorModal from "@/views/admin_dashboard/item/CreateColorModal.vue";
import CreateUnitModal from "@/views/admin_dashboard/item/CreateUnitModal.vue";
import CreateSupplierModal from "@/views/admin_dashboard/item/CreateSupplierModal.vue";
import {useToast} from "vue-toastification";


export default {
  components: {
    CreateCategoryModal,
    Modal,
    Vue3Datepicker,
    VueSelect2,
    CreateWarehouseModal,
    CreateSubCategoryModal,
    CreateSizeModal,
    CreateColorModal,
    CreateUnitModal,
    CreateSupplierModal
  },

  props: ['id'],

  emits: ['create_success'],

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      items: {
        id: null, item_code: '', item_name: '', sku: '', category: null, sub_category: null, size: null, color: null, model_number: '',
        warehouse: null, stock_quantity: '', unit: null, reorder_level: '', manufacturing_date: null, expire_date: null,
        item_serial_number: '', barcode_qr_code: '', supplier_name: null, purchase_price: '', selling_price: '', discount: '', vat_group: 0,  images: []

      },
      categories: [],
      sub_categories: [],
      sizes: [],
      colors: [],
      warehouses: [],
      units: [],
      suppliers: [],
      errors: {},
      errorMessage: "",
      selected_cats_sub_categories: [],
      imagePreview: [],
      existingImages: [],
      newImages: [],
      vat_groups: [],
    };
  },

  mounted() {
    this.fetchDropdownData();
    this.fetchItemData();
  },

  computed: {
    formattedCategories() {
      return this.categories.map(cat => ({ id: cat.id, text: cat.node }));
    },

    formattedsub_categories() {
      return this.selected_cats_sub_categories.map(sub_categorie => ({ id: sub_categorie.id, text: sub_categorie.node }));
    },

    formattedwarehouses() {
      return this.warehouses.map(warehouse => ({ id: warehouse.id, text: warehouse.name }));
    },

    formattedsizes() {
      return this.sizes.map(size => ({ id: size.id, text: size.size }));
    },

    formattedcolors() {
      return this.colors.map(color => ({ id: color.id, text: color.color }));
    },

    formattedunits() {
      return this.units.map(unit => ({ id: unit.id, text: unit.unit }));
    },

    formattedsuppliers() {
      return this.suppliers.map(supplier => ({ id: supplier.id, text: supplier.name }));
    },

    formattedvatgroups() {
      return this.vat_groups.map(group => ({ id: group.id, text: group.vat_group_name }));
    },

  },

  watch: {
    selectedItem: {
      immediate: true,
      handler(newItem) {
        if (newItem && newItem.id) {
          this.items = { ...newItem }; // Copy selected data
        }
      },
    },
  },

  methods: {
    async fetchDropdownData() {
        try {
          const [
            categoriesRes, sub_categoriesRes, sizeRes, colorRes,
            warehouseRes, unitRes, supplierRes, vat_groupRes
          ] = await Promise.all([
            this.$axios.get(apiUrls.categories.get),
            this.$axios.get(apiUrls.sub_categories.get),
            this.$axios.get(apiUrls.item_size.get),
            this.$axios.get(apiUrls.item_color.get),
            this.$axios.get(apiUrls.inventory_warehouse.get),
            this.$axios.get(apiUrls.measurement_unit.get),
            this.$axios.get(apiUrls.inventory_supplier.get),
            this.$axios.get(apiUrls.vat_group.get)
          ]);

          this.categories = categoriesRes?.data || [];
          this.sub_categories = sub_categoriesRes?.data || [];
          this.sizes = sizeRes?.data || [];
          this.colors = colorRes?.data || [];
          this.warehouses = warehouseRes?.data || [];
          this.units = unitRes?.data || [];
          this.suppliers = supplierRes?.data || [];
          this.vat_groups = vat_groupRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

    async fetchItemData() {
      try {
        const response = await this.$axios.get(`${apiUrls.item.get}${this.id}/`);
        this.items = response.data;
        this.existingImages = response.data.images ? [...response.data.images] : [];

        // convert existing dates to ISO for date inputs
        this.items.manufacturing_date = this.parseToISO(this.items.manufacturing_date);
        this.items.expire_date = this.parseToISO(this.items.expire_date);

        this.selected_cats_sub_categories = this.sub_categories;
      } catch (error) {
        this.$toast.error(this.$t('error_fetching_item'));
      }
    },

    parseToISO(dateStr) {
      if (!dateStr) return null;

      const parts = dateStr.split("-");
      if (parts.length === 3) {
        let day = parts[0];
        let month = parts[1];
        let year = parts[2];

        // Convert 2-digit year to 4-digit
        if (year.length === 2) {
          year = "20" + year;
        }

        return `${year}-${month}-${day}`;
      }
      return dateStr;
    },

    async fetchWarehouse() {
      try {
        const response = await this.$axios.get(apiUrls.inventory_warehouse.get);
        this.warehouses = response.data;
      } catch (error) {

      }
    },

    async fetchCategory() {
      try {
        const response = await this.$axios.get(apiUrls.categories.get);
        this.categories = response.data;
      } catch (error) {

      }
    },

    async fetchSubCategory() {
      try {
        const response = await this.$axios.get(apiUrls.sub_categories.get);
        this.sub_categories = response.data;
      } catch (error) {

      }
    },

    async fetchSize() {
      try {
        const response = await this.$axios.get(apiUrls.item_size.get);
        this.sizes = response.data;
      } catch (error) {

      }
    },

    async fetchColor() {
      try {
        const response = await this.$axios.get(apiUrls.item_color.get);
        this.colors = response.data;
      } catch (error) {

      }
    },

    async fetchUnit() {
      try {
        const response = await this.$axios.get(apiUrls.measurement_unit.get);
        this.units = response.data;
      } catch (error) {

      }
    },

    async fetchSupplier() {
      try {
        const response = await this.$axios.get(apiUrls.inventory_supplier.get);
        this.suppliers = response.data;
      } catch (error) {

      }
    },

    async fetchVatGroup() {
      try {
        const response = await this.$axios.get(apiUrls.vat_group.get);
        this.vat_groups = response.data;
      } catch (error) {

      }
    },

    onChangeCategory(selectedValue) {
        this.fetchCatSubCategories(selectedValue.id);
      },

    async fetchCatSubCategories(categoryACCId) {
      try {
        const response = await this.$axios.get(`${apiUrls.sub_categories.get}`, {
          params: { category_id: categoryACCId }
        });
        this.selected_cats_sub_categories = response.data;

      } catch (error) {

      }
    },

    imageUpload(event) {
      const files = event.target.files;
      if (!files || !files.length) return;

      const total = this.existingImages.length + this.newImages.length + files.length;

      if (total > 2) {
        this.errors.images = this.$t('error.max_images');
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.newImages.push(file);

        const preview = URL.createObjectURL(file);
        this.imagePreview.push(preview);
      }
    },

    removeExistingImage(index) {
      this.existingImages.splice(index, 1);
    },

    removeImage(index) {
      this.items.images.splice(index, 1);
      this.imagePreview.splice(index, 1);
      this.newImages.splice(index, 1);
    },

    async updateItem() {
      this.errors = {};
      if (!this.items.item_code) this.errors.item_code = this.$t('error.required');
      if (!this.items.item_name) this.errors.item_name = this.$t('error.required');
      if (!this.items.category) this.errors.category = this.$t('error.required');
      if (!this.items.sub_category) this.errors.sub_category = this.$t('error.required');
      if (!this.items.size) this.errors.size = this.$t('error.required');
      if (!this.items.color) this.errors.color = this.$t('error.required');
      // if (!this.items.warehouse) this.errors.warehouse = this.$t('error.required');
      // if (!this.items.stock_quantity) this.errors.stock_quantity = this.$t('error.required');
      if (!this.items.unit) this.errors.unit = this.$t('error.required');
      // if (!this.items.supplier_name) this.errors.supplier_name = this.$t('error.required');
      if (!this.items.purchase_price) this.errors.purchase_price = this.$t('error.required');
      if (!this.items.selling_price) this.errors.selling_price = this.$t('error.required');

      if (Object.keys(this.errors).length > 0) return;

      const formData = new FormData();

      // Append normal fields
      Object.keys(this.items).forEach(key => {
        if (key !== "images") {
          formData.append(key, this.items[key]);
        }
      });

      // Send remaining existing images (after deletion)
      formData.append("existing_images", JSON.stringify(this.existingImages));

      // Send new uploaded files
      this.newImages.forEach(file => {
        formData.append("new_images[]", file);
      });

      try {
        await this.$axios.put(
          apiUrls.item.update.replace(":pk", this.items.id),
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        this.toast.success("Item successfully updated!");
        this.$router.push("/items");
        this.$emit("create_success");
        this.resetForm();

      } catch (error) {

        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }

      }
    },

    cancelForm() {
      this.$router.push('/items');
    },

    resetForm() {
        // Reset form fields and errors
        this.items = {
          item_code: '', item_name: '', sku: '', category: '', sub_category: '', size: '', color: '', model_number: '',
          warehouse: '', stock_quantity: '', unit: '', reorder_level: '', manufacturing_date: '', expire_date: '',
          item_serial_number: '', barcode_qr_code: '', supplier_name: '', purchase_price: '', selling_price: '', discount: '', vat_group: '', images: ''

        };
        this.errors = {};
        this.errorMessage = "";
      },

    onChange(event) {
      console.log('Value changed:', event);
    }
  },

  async created() {
    await this.fetchItemData();
    await this.fetchWarehouse();
    await this.fetchCategory();
    await this.fetchSubCategory();
    await this.fetchSize();
    await this.fetchColor();
    await this.fetchUnit();
    await this.fetchSupplier();
    await this.fetchCatSubCategories();
    await this.fetchVatGroup();
  },
};
</script>
